import React from 'react'
import { useParams } from 'react-router-dom';

export default function PackingSlip() {
  const packingSlipId = useParams().id;
      const url = `https://rlugroup.in/pdf/convert?fileName=rlugroup-packing-slip.hbs&id_field=packingSlipNumber&format=A5&margintop=0.2cm&url=https://rlugroup.in/api/packing-slip/details/${packingSlipId}`;
      return (
          <object data={url} type="application/pdf" width="100%" height={window.innerHeight} aria-label="Packing Slip PDF">
              Packing Slip PDF
          </object>
      )
}